import { ApiData, getEntitiesPerStoreAsync, Query, ReportResource, Result } from '../Reports';

import { ApiExpensesAggregate, ApiExpensesField, ExpenseInfo } from './types';

export const mapApiDataToExpenseInfo = (apiData: ApiData): ExpenseInfo => ({
  amountExclTax: Number(apiData[ApiExpensesField.SumExpenseTaxExcluded]),
  amountInclTax: Number(apiData[ApiExpensesField.SumExpenseTaxIncluded]),
  amountTax: Number(apiData[ApiExpensesField.SumExpenseTaxAmount]),
  nbPayments: Number(apiData[ApiExpensesField.NbExpenses]),
  paymentMethod: String(apiData[ApiExpensesField.ExpensePaymentType]),
  reason: String(apiData[ApiExpensesField.ExpenseLabel]),
});

export const getExpensesPerStoreAsync = async (query: Query): Promise<Result<ExpenseInfo>> =>
  getEntitiesPerStoreAsync<ExpenseInfo>(
    {
      ...query,
      resource: ReportResource.Expenses,
      aggregates: [ApiExpensesAggregate.Label, ApiExpensesAggregate.PaymentType],
      closedTillLimitation: true,
    },
    mapApiDataToExpenseInfo,
  );
